import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';

const formatAndMergePhotographyData = (oldPhotographyData, newPhotographyData) => {

    let local_data = [];

    if (oldPhotographyData !== undefined){
        Utils.mergeBasicOldData(oldPhotographyData, local_data)
    }
    if (newPhotographyData !== undefined){
        Utils.mergeBasicNewData(local_data, newPhotographyData, "picture")
                }
    return local_data;
}

//Const to import functions in other files
const PhotographyDataManager = {
  formatAndMergePhotographyData
};

export default PhotographyDataManager;